export const status = {
    null : "pending_to_upload",
    // USER, VEHICLES status  1 - 10 //
    1: "pre_registered", // colors.grey
    2: "to_change_password", // colors.yellow
    3: "to_approve_document", // colors.blue
    4: "active", // colors.green
    5: "on_vacations", // colors.orange
    6: "in_active", // colors.red
    7: "account_locked",
    8: "identity_theft",
    // COMPANY Status 11 -  20 //
    11: "active_company", // colors.blue
    12: "inactive_company", // colors.blue
    13: "zone_in_construction_company", // colors.blue
    14: "start_date", // colors.blue
    15: "end_date", // colors.blue
    16: "IN_USE_COMPANY", // colors.blue
    17: "REMOVED_COMPANY", // colors.blue
    18: "DOCUMENT_IN_VALIDATION", // colors.blue
    19: "DOCUMENT_VALIDATED", // colors.blue
    20: "DOCUMENT_REJECTED", // colors.blue

    // CONTRACTOR 21-25 //
    24: "contract_active", // colors.grey
    25: "contract_finished", // colors.yellow

    // SUPPLIER 26-30 //
    26: "supplier_active", // colors.blue
    27: "supplier_inactive", // colors.blue

    // EVENTS 31-35 //
    31: "event_cancel", // colors.red
    32: "reservation_booked", // colors.blue EVENT_ACTIVE

    // HOLIDAYS 41-49 //
    41: "HOLIDAY_PENDING_TO_VALIDATE", // colors.grey
    42: "HOLIDAY_DENIED", // colors.red
    43: "HOLIDAY_APPROVED", // colors.green
    44: "HOLIDAY_CANCELED", // colors.orange

    // CONTRACTS 50 - 59 //
    50: "CONTRACT_INCOMING", // colors.grey
    51: "contract_active", // colors.green
    52: "CONTRACT_CANCEL", // colors.red
    53: "contract_finished", // colors.blue

    // ORDERS 60 - 69 //
    60: "ORDER_INCOMING", // colors.grey
    61: "ORDER_STARTED", // colors.blue
    62: "ORDER_COMPLETE", // colors.green

    // TRAVEL 70 - 79 //
    70: "TRAVEL_IN_TRANSIT", // colors.grey
    71: "TRAVEL_ENTRY_REVISION", // colors.blue
    72: "TRAVEL_DOWNLOAD_ITEM", // colors.blue
    73: "TRAVEL_EXIT_REVISION", // colors.blue
    74: "TRAVEL_DELIVERED", // colors.green
    75: "TRAVEL_NOT_ACCEPTED", // colors.orange
    76: "TRAVEL_CANCELED", // colors.red

    //File 80 - 89 //
    80: 'REPORT_GENERATING',
    81: 'REPORT_READY',
    82: 'REPORT_SERVER_ERROR',
    83: 'REPORT_GENERATING_ERROR',
    84: 'REPORT_EXPIRED',

    // LOGISTIC TRANSPORT 90 - 99 //
    90: "REQUESTED",
    91: "ASSIGNED",
    92: "ACCEPTED",
    93: "IN_TRANSIT",
    94: "DELIVERED",
    95: "REJECTED",
    96: "CANCELED",

    // VISITOR 110 - 139 //
    110: "PENDING_TO_APPROVE",
    111: "PENDING_TO_UPLOAD_INFORMATION",
    112: "UNATTENDED",
    113: "VALIDATED",

    130: "APPROVED",
    131: "CHANGES_REQUESTED",
    132: "DENIED",
    133: "PENDING_REVIEW",
    135: "IN_PROGRESS",

    153: "ISSUED",
    154: "PAID",
    155: "OVERDUE",
    156: "SUSPENDED",
    157: "DRAFT",

    160: "ADJUSTED",
    161: "PENDING_TO_DISPATCH",
    162: "DISCREPANCY",
    163: "DISPATCHED",
    164: "PENDING_ARRIVAL",
    165: "PENDING_DEPARTURE",
    166: "DEPARTURE_RECORDED",
    167: "ARRIVAL_RECORDED",
    168: "PENDING_TO_REVIEW",

    1000: "pending", //Status used only in the FRONTEND
    1001: "REVIEW_NEEDED",//Status used only in the FRONTEND
};

export const STATUS_MODEL = {
    "PENDING_TO_UPLOAD" : null,
    "PRE_REGISTERED":1,
    "TO_CHANGE_PASSWORD": 2,
    "TO_APPROVE_DOCUMENT":3,
    "ACTIVE" : 4,
    "INACTIVE": 6,
    "ACCOUNT_LOCKED": 7,
    "IDENTITY_THEFT": 8,
    "ACTIVE_COMPANY": 11,
    "IN_ACTIVE_COMPANY": 12,
    "DOCUMENT_IN_VALIDATION":18,
    "DOCUMENT_VALIDATED" : 19,
    "DOCUMENT_REJECTED" : 20,
    "SUPPLIER_ACTIVE" : 26,
    //events
    "BOOKED":32,

    "CONTRACT_FINISH":53,
    "ORDER_INCOMING" : 60,
    "ORDER_STARTED" : 61,
    "ORDER_COMPLETE" : 62,

    "REPORT_GENERATING" : 80,
    "REPORT_READY" : 81,
    "REPORT_SERVER_ERROR" : 82,
    "REPORT_GENERATING_ERROR" : 83,
    "REPORT_EXPIRED" : 84,

    "REQUESTED":90,
    "ASSIGNED":91,
    "ACCEPTED":92,
    "IN_TRANSIT":93,
    "DELIVERED":94,
    "REJECTED":95,
    "CANCELED":96,

    "PENDING_TO_APPROVE": 110,
    "PENDING_TO_UPLOAD_INFORMATION" : 111,
    "UNATTENDED": 112,
    "VALIDATED": 113,

    "APPROVED": 130,
    "CHANGES_REQUESTED": 131,
    "DENIED": 132,
    "PENDING_REVIEW": 133,
    "IN_PROGRESS": 135,
    "FOODIE_USER_SELECTION_BOOKED": 150,
    "FOODIE_USER_SELECTION_CHECK_IN": 151,
    "FOODIE_USER_SELECTION_SERVED": 152,

    "ISSUED" :153,
    "PAID" :154,
    "OVERDUE" :155,
    "SUSPENDED" :156,

    "DRAFT" : 157,

    "ADJUSTED" : 160,
    "PENDING_TO_DISPATCH": 161,
    "DISCREPANCY": 162,
    "DISPATCHED": 163,
    "PENDING_ARRIVAL": 164,
    "PENDING_DEPARTURE": 165,
    "DEPARTURE_RECORDED": 166,
    "ARRIVAL_RECORDED": 167,
    "PENDING_TO_REVIEW": 168,

    "PENDING":1000, //Status used only in the FRONTEND
    "REVIEW_NEEDED" : 1001, //Status used only in the FRONTEND
}

export const getStatusNameById = (id) => {
        return Object.keys(STATUS_MODEL).find((key) => STATUS_MODEL[key] === id);
    };
export const getStatusIdsByNames = (statusMap, names) => {
    const keys = Object.keys(statusMap);
    return keys
        .filter((key) => names.includes(statusMap[key]))
        .map(Number);
    };
